import React, { Component } from 'react'
import PDFToolbar from './PDFToolbar'

import '../scss/PDFToolbarContainer.scss'


class PDFToolbarContainer extends Component {

  render () {
    return (
      <div className="PDFToolbarContainer" data-display={this.props.display}>
        <PDFToolbar {...this.props} />
      </div>
    )
  }
}

export default PDFToolbarContainer
